import { Form, Row } from "antd";
import { useSetting } from "../../util/settings";
import FormItem, { createRegexRule } from "../../form/form-item";
import { AdvancedForm } from "../../form/advanced-form";

export const useInvoiceSetting = () => {
  return useSetting("invoice", "application", {
    addressName: "",
    addressStreet: "",
    addressHousenumber: "",
    addressZipCode: "",
    addressCity: "",
    contactPerson: "",
  })
}

function InvoiceSettingsPage() {
  const [form] = Form.useForm();
  const [invoiceSetting, updateInvoiceSetting] = useInvoiceSetting();

  return (
    <AdvancedForm form={form} name="advanced_search" onFinish={updateInvoiceSetting} originalValues={invoiceSetting}>
      <Row><h3>Rechnungseinstellungen</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="addressName" label="Firmenname" />
        <FormItem fieldName="contactPerson" label="Ansprechpartner" />
      </Row>
      <Row gutter={24}>
        <FormItem fieldName="addressStreet" label="Straße" />
        <FormItem fieldName="addressHousenumber" label="Hausnummer" />
        <FormItem fieldName="addressZipCode" label="PLZ" rules={[createRegexRule(/^\d{5}$/, 'Keine gültige PLZ')]} />
        <FormItem fieldName="addressCity" label="Ort" />
      </Row>
    </AdvancedForm>
  )
}

export default InvoiceSettingsPage;